export default __webpack_public_path__ + "a9c59ec8177700bc9b55b073dc96eeaa.png";